import { Component, h, State } from '@stencil/core';
import { getServiceNumber } from '../../utils/ttarp';
import { isBrowser } from '../../constants/constants';
import phoneIcon from '../../assets/phone_red.svg';
import mailIcon from '../../assets/mail_red.svg';
import { getOrSetFeatureAssignment } from '../../utils/scSignalman';
import { isBeforePromoExpiry } from '../../utils/promoExpire';

@Component({
  tag: 'ci-footer',
  styleUrl: 'ci-footer.scss',
  shadow: true,
})
export class CustominkFooter {
  @State() serviceNumber: string = '';
  @State() adTest: boolean = false;

  async componentWillLoad() {
    if (isBrowser) {
      const fetchedServiceNumber = await getServiceNumber();
      this.serviceNumber = fetchedServiceNumber;

      try {
        const assignment = await getOrSetFeatureAssignment('drinkware_promo_ad_v2');
        this.adTest = assignment === 'on' && isBeforePromoExpiry();
      } catch (_err) { }
    }
  }

  render() {
    return (
      <footer class="ci-Footer ci-Footer--condensed">
        <div class="ci-Footer-body">
          <div class="pigment-wrapper">
            {this.adTest && (
            <div class="ci-Footer-bannerAd" id="footer-banner-ad-terms"><strong class="ci-Footer-bannerAd-offer">*20% Off Drinkware Promo:</strong> Valid thru 11:59 PM PDT 5/26/25. Prices as marked. Discount does not apply to taxes or shipping.
              Cannot be combined with other rebates or offers, including <span class="ci-Footer-bannerAd-nowrap">negotiated pricing.</span></div>
            )}
            <div class="ci-Footer-bodyLayout">
              <nav class="ci-Footer-bodyList--hours">
                <div class="ci-Footer-bodyList-itemHeader">
                  Talk to a Real Person <br /> 7 Days a Week
                </div>
                <div class="ci-Footer-bodyList-list">
                  <div class="ci-Footer-bodyList-itemHour">8am-Midnight ET Mon-Fri</div>
                  <div class="ci-Footer-bodyList-itemHour">10am-6pm ET Saturday</div>
                  <div class="ci-Footer-bodyList-itemHour">10am-6pm ET Sunday</div>
                </div>
              </nav>
              <div class="ci-Footer-bodyList--contact">
                {isBrowser && (
                  <a class="ci-Footer-bodyList-chat" href={`tel:${this.serviceNumber}`} title="Phone with Sound Waves">
                    <img src={phoneIcon} alt="Phone with Sound Waves" class="img" />
                    <span class="ci-Footer-bodyList-chat-text" >
                      {this.serviceNumber}
                    </span>
                  </a>
                )}
                <a class="ci-Footer-bodyList-email" href="https://www.customink.com/contact" title="Phone with Sound Waves">
                  <img src={mailIcon} alt="Mail Envelop" class="img" />
                  <span class="ci-Footer-bodyList-email-text">
                    Send us an Email
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="ci-FooterCoda">
          <div class=" ci-FooterCoda-wrapper pigment-wrapper">
            <nav class="ci-FooterCoda-nav">
              <div class="ci-FooterCoda-horizontal-list">
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/ink/apparel`}>Custom Apparel</a>
                </span>
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/custom/custom-koozies`}>Custom Koozies</a>
                </span>
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/ink/custom-products`}>Custom Products</a>
                </span>
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/products/promotional-products/218`}>Promotional Items</a>
                </span>
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/ink/sitemap`}>Site Map</a>
                </span>
                <span>
                  <a href="https://swag.com">Swag.com</a>
                </span>
              </div>
            </nav>
            <div class="ci-FooterCoda-links">
              <div class="ci-FooterCoda-horizontal-list">
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/about/privacy`}>Privacy Policy</a>
                </span>
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/about/ccpa`}>California Privacy Policy</a>
                </span>
                <span>
                  <a href={`${process.env.CI_HOSTNAME}/about/user_agreement`}>User Agreement</a>
                </span>
              </div>
            </div>
            <div class="ci-FooterCoda-copyright">&copy; {new Date().getFullYear()} CustomInk, LLC. All rights reserved.</div>
            <div class="ci-FooterCoda-trademark">Custom Ink is a registered trademark of CustomInk LLC.</div>
          </div>
        </div>
      </footer >
    );
  }
}
